import { createApp } from "vue";
import App from "./App.vue";

import router from "@/core/router";
// import store from "@/core/store";
// import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import { BootstrapIconsPlugin } from 'bootstrap-icons-vue';

//imports for app initialization
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import "bootstrap";

// import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
// import unleashClient from "@/core/services/unleashClient"
// import store from "@/core/store/PersistentStorage";

import unleash from '@/core/services/unleashClient';

const app = createApp(App);

// app.use(store);
app.use(router);
// app.use(ElementPlus);
app.use(BootstrapIconsPlugin);

initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

// app.use(unleashPlugin, { unleashClient: unleashClient })

// await unleashClient.start()

// if (store.authentication.user?.districtId) {
//     console.log('main.ts if store.authentication.user?.districtId')
//     unleashClient.setContextField('districtId', store.authentication.user.districtId);
// }
// else {
//     unleashClient.setContextField('districtId', '');
// }

// if (store.authentication.user?.currentInstance?.gradeId) {
//     console.log('main.ts if store.authentication.user?.gradeId')
//     unleashClient.setContextField('gradeId', store.authentication.user.currentInstance.gradeId);
// }
// else {
//     unleashClient.setContextField('gradeId', '');
// }

app.mount("#app");

// Start the background polling
unleash.start();
